/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { default as MuiTooltip } from "@mui/material/Tooltip";
import { CircleQuestionIcon } from "../../FontAwesome";
import AnyUtil from "../../Utils/AnyUtil";
import "./Tooltip.scss";

export interface TooltipProps {
    title?: React.ReactNode;
    containerStyle?: TooltipContainerStyle;
    iconColor?: string;
}

export enum TooltipContainerStyle {
    flex = "flex",
    inline = "inline",
}

export default function Tooltip({ title, containerStyle, iconColor }: TooltipProps) {
    if (AnyUtil.isNullOrUndefined(title)) {
        return null;
    }

    return (
        <div className={`lan-tooltip__container__${containerStyle ?? TooltipContainerStyle.flex}`}>
            <MuiTooltip
                disableFocusListener
                title={title}
                PopperProps={{ className: "lan-tooltip__popper" }}
                classes={{ tooltip: "lan-mui-tooltip" }}
            >
                {!!iconColor ? (
                    <span><CircleQuestionIcon className="lan-tooltip__icon" htmlColor={iconColor} /></span>
                ) : (
                    <span><CircleQuestionIcon className="lan-tooltip__icon" color="secondary" /></span>
                )}
            </MuiTooltip>
        </div>
    );
}
